export enum DiscountProductSortType {
  MostExpensiveFirst = 0,
  CheapestFirst = 1,
}
